import { PropsWithChildren } from "react";
import styled from "styled-components";
import { cssVariables } from "../../styles";

// left and top props are passed to offset the tooltip by cursor coordinates.
// Using mouse event clientX,Y or pageX,Y coordinates
interface Props {
  left: number;
  top: number;
}

export const Tooltip: React.FC<PropsWithChildren<Props>> = ({
  children,
  left,
  top,
}) => {
  return (
    <TooltipContainer left={left} top={top}>
      {children}
    </TooltipContainer>
  );
};

interface TooltipProps {
  left: number;
  top: number;
}

const TooltipContainer = styled.span.attrs<TooltipProps>(props => ({
  style: {
    left: props.left + "px",
    top: props.top + "px",
  },
}))<TooltipProps>`
  position: fixed;
  color: ${cssVariables.colors.white};
  display: none;
  padding: 2rem;
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 2.4rem;
  background-color: ${cssVariables.colors.black};
  opacity: 0.9;
  z-index: 1000;
`;
